module.exports = __webpack_public_path__ + "static/media/home.14db5d0d.svg";